import React from 'react'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import intl from 'react-intl-universal'
import { Container } from 'components/qstrap'
import { Link, Redirect } from 'react-router-dom'
import scrollTo from 'utils/ui/scrollTo'
import AptitudeProgressBar from 'components/molecules/AptitudeProgressBar'
import AptitudeQuestionItem from 'components/molecules/AptitudeQuestionItem'
import AptitudeInstructionBar from 'components/organisms/AptitudeInstructionBar'

class AptitudeTest extends React.Component {
  constructor(props) {
    super(props)

    if (typeof localStorage !== 'undefined') {
      this.pageStorage = localStorage.getItem('aptitude_page') || 1
    } else {
      this.pageStorage = 1
    }

    this.maxPageRiasec = 0
    this.maxPageCharcs = 0

    if (props.allPageItems.length !== 0) {
      props.allPageItems.forEach((pageItems) => {
        if (pageItems[0].factor_group === 'riasec') {
          this.maxPageRiasec += 1
        } else {
          this.maxPageCharcs += 1
        }
      })
    }

    this.state = {
      allFilled: false,
      answeredCount: 0,
    }

    this.currentPage = this.currentPage.bind(this)
    this.currentPageItems = this.currentPageItems.bind(this)
    this.values = this.values.bind(this)
    this.onAnswer = this.onAnswer.bind(this)
    this.nextButtonClass = this.nextButtonClass.bind(this)
    this.nextButtonOnClick = this.nextButtonOnClick.bind(this)
  }

  componentDidMount() {
    scrollTo('top')
  }

  componentDidUpdate(prevProps) {
    if (Number(prevProps.match.params.page) !== this.currentPage()) this.onAnswer()
    if (this.state.allFilled) scrollTo('bottom')
  }

  onAnswer() {
    const answers = this.values()

    this.setState({
      allFilled: (answers.indexOf(0) === -1),
      answeredCount: (answers.filter(answer => answer !== 0).length),
    })
  }

  currentPageItems() {
    return this.props.allPageItems[this.currentPage() - 1]
  }

  currentPage() {
    return Number(this.props.match.params.page)
  }

  values() {
    const that = this
    const answers = []

    Object.keys(that.refs).forEach((key) => {
      answers.push(that.refs[key].state.answer)
    })

    return answers
  }

  nextButtonClass() {
    return this.state.allFilled ? '' : 'disabled'
  }

  nextButtonOnClick(e) {
    this.pageStorage = this.currentPage() + 1
    localStorage.setItem('aptitude_page', this.pageStorage)
    e.target.blur()
    scrollTo('top')
  }

  render() {
    if (Number(this.pageStorage) > this.props.allPageItems.length) {
      return <Redirect to="/aptitude_test/calculate" />
    }

    if (Number(this.pageStorage) !== this.currentPage()) {
      return <Redirect to={`/aptitude_test/test/${this.pageStorage}`} />
    }

    const factorGroup   = this.currentPageItems()[0].factor_group
    const factorMaxPage = factorGroup === 'riasec' ? this.maxPageRiasec : this.maxPageCharcs
    const factorPage    = factorGroup === 'riasec' ? this.currentPage() : (this.currentPage() - this.maxPageRiasec)

    return (
      <div id="AptitudeTest">
        <AptitudeProgressBar
          page={factorPage}
          maxPage={factorMaxPage}
          pageName={intl.get(`aptitude.questions.bar.${factorGroup}.page_name`)}
          answeredCount={this.state.answeredCount}
          questionsSize={this.currentPageItems().length}
        />

        <AptitudeInstructionBar page={factorPage} factor={factorGroup} />

        <div id="question-list">
          <Container>
            {this.currentPageItems().map((val, i) => {
              const id = `${this.currentPage()}-${i + 1}-${val.factor}`
              const number = ((factorPage - 1) * 10) + i + 1

              return (
                <AptitudeQuestionItem
                  ref={`question_${i}`}
                  key={id}
                  id={id}
                  content={val}
                  factorGroup={factorGroup}
                  onAnswer={this.onAnswer}
                  number={number}
                />
              )
            })}
            <div id="next-question-container">
              <Link
                to={`/aptitude_test/test/${this.currentPage() + 1}`}
                className={`btn btn-primary btn-campus ${this.nextButtonClass()}`}
                onClick={(e) => { this.nextButtonOnClick(e) }}
              >
                {intl.get('next')}
              </Link>
            </div>
          </Container>
        </div>
      </div>
    )
  }
}

AptitudeTest.propTypes = {
  allPageItems: PropTypes.array.isRequired,
}

export { AptitudeTest }
export default branch({
  allPageItems: ['serverProps', 'aptitude_items'],
}, AptitudeTest)
